import { Injectable } from '@angular/core';
import { catchError, Observable, of, ReplaySubject } from 'rxjs';
import { MeteorologyObservations, MeteorologyForecast } from './meteorologi.types';
import { MeteorologiService } from './meteorologi.service';
import { theTime } from 'src/app/utils/date-utils';

@Injectable({
  providedIn: 'root'
})
export class MeteorologiDataService {
  selectedObjectId: string;

  private _meteorologyObservationsData$ = new ReplaySubject<MeteorologyObservations>(
    undefined
  );
  private _meteorologyForecastData$ = new ReplaySubject<MeteorologyForecast>(
    undefined
  );

  meteorologyObservations$: Observable<MeteorologyObservations | undefined> =
    this._meteorologyObservationsData$.asObservable();
  meteorologyForecast$: Observable<MeteorologyForecast | undefined> =
    this._meteorologyForecastData$.asObservable();

  constructor(private _meteorologiService: MeteorologiService) { }

  reset() {
    // reset observations
    this._meteorologyObservationsData$ = new ReplaySubject<MeteorologyObservations>(
      undefined
    );
    this.meteorologyObservations$ = this._meteorologyObservationsData$.asObservable();
    // reset forecast
    this._meteorologyForecastData$ = new ReplaySubject<MeteorologyForecast>(
      undefined
    );
    this.meteorologyForecast$ = this._meteorologyForecastData$.asObservable();
  }

  fetchData(objectId: string) {
    if (objectId) {
      this.selectedObjectId = objectId;
      const selectedPeriod = theTime().to(["YYYY", "MM"]);

      this._meteorologiService
        .getObservations(objectId, selectedPeriod)
        .pipe(catchError((err) => of({} as MeteorologyObservations))) // fallback to empty object instead of error, avoid subject completion
        .subscribe({
          next: (res) => {
            this._meteorologyObservationsData$.next(res);
          }
        });
      this._meteorologiService
        .getForecast(objectId)
        .pipe(catchError((err) => of({} as MeteorologyForecast))) // fallback to empty object instead of error, avoid subject completion
        .subscribe({
          next: (res) => {
            this._meteorologyForecastData$.next(res);
          }
        });
    }
  }
}
